import { navigateInGame } from '../../../config/boot/inGameNavigation';

/** Reboot the creator's newly selected hero on the server-authored story map.
 * Mode configuration is resolved at module load, so changing the address with
 * history.replaceState would leave the room join on the old roster map. */
export function freshCharacterEntryUrl(levelId: string | undefined, current: URL): string | null {
  const entryMap = levelId?.trim();
  if (!entryMap) return null;

  const params = new URLSearchParams({
    map: entryMap,
    preset: 'live-lobby',
    skipSplash: '1',
    skipLogin: '1',
    keepCharacter: '1',
  });
  for (const flag of ['freezePopup', 'testhooks', 'renderer']) {
    const value = current.searchParams.get(flag);
    if (value !== null) params.set(flag, value);
  }
  return `/?${params.toString()}`;
}

export function navigateFreshCharacter(url: string): void {
  navigateInGame(url);
}
